<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Treatment Follow Up</h1>
      </div>
  </div>
</section>
<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">
        <div class="d-grid doctor-appointment"  style="width: 1500px;">
            <div class="appointment-form">
                <form action="#" method="post">
                    <div class="fields-grid">
                        <!----**********  Date ******-------->
                        <div class="styled-input">
                          <label>Date</label>
                          <label style="width: 45%;"></label>
                          <label>No. of cycle</label>
                          <div class="appointment-form-field">
                               <span class="fa fa-calendar" aria-hidden="true"></span>
                               <input type="date" [(ngModel)]="tttdate" name="date" id="wdate" required=""  style="width: 38%;font-size: 80%;" >
                               <input type="text" [(ngModel)]="tttnoofcycle" name="tttnoofcycle" id="tttnoofcycle" required=""  style="width: 60%;">

                          </div>
                       </div>
                       <!----**********  Patient Info ******-------->
                       <div class="styled-input">
                        <label>Patient ID</label>
                        <label style="width: 20%;"></label>
                        <label>Patient Name</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" matTooltip="Search" (click)="openDialog()" ></span>
                            <span class="fa fa-list-alt" aria-hidden="true" style="cursor: grab;" matTooltip="Advanced Search"  (click)="OpenDialogRes()" ></span>
                            <input type="text" name="patientId" maxlength="8ch" placeholder="Patient ID"  maxlength="50ch" required="" style="width: 40%;" [(ngModel)]="pacode" (change)="RetrivePatient()">
                            <input type="text" name="pfullname" placeholder="" required="" id="pfullname" [(ngModel)]="paname"  maxlength="100ch">
                          </div>
                       </div>
                        <!----**********  Cancer Type ******-------->
                        <div class="styled-input">
                          <label>Cancer Type</label>

                          <div class="appointment-form-field">
                              <span class="fa fa-medkit" aria-hidden="true" style="cursor: grab;" ></span>
                              <input type="text" name="cancerid" maxlength="50ch"  maxlength="50ch" required="" style="width: 90%;background-color: rgba(0, 0, 255, 0.141);" [(ngModel)]="cancerid" >
                            </div>
                        </div>
                        <!----**********  Diaganosis ******-------->
                        <div class="styled-input">
                          <label>Diaganosis</label>
                          <div class="appointment-form-field">
                              <span class="fa fa-stethoscope" aria-hidden="true" style="cursor: grab;"   ></span>
                              <input type="text" name="diganosis" maxlength="50ch"  maxlength="50ch" required="" style="width: 90%;background-color: rgba(0, 0, 255, 0.141);" [(ngModel)]="diganosis" >
                            </div>
                        </div>
                        <!----**********  Pan ID ******-------->
                        <div class="styled-input">
                        <label>Plan ID</label>
                        <label style="width: 40%;"></label>
                        <label>Plan Name</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-hotel" aria-hidden="true"></span>
                            <input type="text" [(ngModel)]="tttplanid"  maxlength="50ch" name="tttplanid" id="tttplanid" required=""  style="width: 50%;">
                            <input type="text" [(ngModel)]="tttplanname"  maxlength="150ch" name="tttplanname" id="tttplanname" required=""  style="width: 60%;">

                          </div>
                        </div>

                        <!----**********  CBC ******-------->
                        <div class="styled-input">
                        <label style="width: 27%;">CBC H.B</label>
                        <label  style="width: 23%;">CBC TLC</label>
                        <label  style="width: 25%;">CBC PNL's</label>
                        <label  style="width: 25%;">CBC PLAT</label>

                          <div class="appointment-form-field">
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input type="text"  [(ngModel)]="cbchb"  maxlength="10ch" name="cbchb"  required="" style="width: 40%;">
                              <label style="width: 5%;"></label>
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input   [(ngModel)]="cbctlc"  maxlength="5ch" name="cbctlc"  required="" style="width: 40%;">
                              <label style="width: 5%;"></label>
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input   [(ngModel)]="cbcpnl" maxlength="5ch" name="cbcpnl"  required="" style="width: 40%;">
                              <label style="width: 5%;"></label>
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input   [(ngModel)]="cbcplat" maxlength="5ch" name="cbcplat"  required="" style="width: 40%;">

                          </div>

                        </div>
                       <!----**********  Protocol ******-------->
                        <div class="styled-input">
                          <label>Protocol</label>
                          <div class="appointment-form-field">

                            <span type="submit" class="fa fa-search" (click)="LoockupProtocols()" style="cursor: grab;"></span>
                            <input type="text" name="protocolId" placeholder="Protocol ID" style="width: 40%;" maxlength="10ch"
                              [(ngModel)]="protocol" required disabled>

                            <input type="text" name="ProtocolName" disabled style="width: 90%;" [(ngModel)]="protocolname">
                          </div>
                        </div>
                      <!----**********  Dose ******-------->
                      <div class="styled-input">
                        <label style="width: 27%;">Dose</label>
                        <label  style="width: 23%;">Unit</label>
                        <label  style="width: 25%;">Rote</label>
                        <label  style="width: 25%;">Day</label>

                          <div class="appointment-form-field">
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input type="number"  [(ngModel)]="tttdose" name="time"  required="" style="width: 20%;">
                              <label style="width: 5%;"></label>
                              <select id="Units" name="unit1" required="" style="width: 25%;background-color: white;" [(ngModel)]="tttunit" [value]="tttunit">
                                <option value="{{unit1.unCode}}" *ngFor="let unit1 of finalunitsList; let i = index">{{unit1.unName}}
                                </option>
                              </select>
                              <label style="width: 5%;"></label>
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input   [(ngModel)]="tttrote" name="time1"  required="" style="width: 20%;">
                              <label style="width: 5%;"></label>
                              <span class="fa fa-hourglass" aria-hidden="true"></span>
                              <input   [(ngModel)]="tttday" name="time1"  required="" style="width: 20%;">

                          </div>

                        </div>
                           <!----**********  Next Date ******-------->
                           <div class="styled-input">
                            <label>Next Cycle</label>
                            <label style="width: 45%;"></label>
                            <label>Cycle No.</label>
                            <div class="appointment-form-field">
                                 <span class="fa fa-calendar" aria-hidden="true"></span>
                                 <input type="date" [(ngModel)]="tttnextcycle" name="tttnextcycle" id="tttnextcycle" required=""  style="width: 50%;font-size: 80%;" >
                                 <input type="text" [(ngModel)]="tttcycleno" name="tttcycleno" maxlength="3ch" id="tttcycleno" required=""  style="width: 50%;font-size: 80%;" >

                            </div>
                         </div>
                        <!----**********  Doctor ******-------->
                        <div class="styled-input">
                        <label>Doctor </label>
                        <div class="appointment-form-field">
                          <span class="fa fa-headphones" aria-hidden="true"></span>
                          <select id="doctor" name="doctor" required="" [(ngModel)]="doctor" [value]="docName">
                            <option value="{{doc.docCode}}"  *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
                        </select>
                         </div>
                        </div>
                        <!----**********  Notes ******-------->
                        <div class="styled-input">
                          <label>Notes</label>
                           <BR>
                           <BR>
                          <div class="appointment-form-field">
                            <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                            <textarea rows = "5" cols = "60" name = "description" class="appointment-form-field" style="height: 200%;" [(ngModel)]="tttnotes"placeholder ="Enter details here... "  maxlength="150ch"> </textarea><br>
                        </div>
                        </div>

                        <button type="button"  name="submit"  style="width:  20%;height:50px; border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);"  (click)="Save_Data()">Submit</button>
                        <button type="button"  name="Delete" style="width:  20%;height:50px; border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);"(click)="MesgDelete()" >Delete</button>
                        <button type="button"  name="New" style="width:  20%;height:50px; border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);" (click)="New_Data()">New</button>
                        <button type="button"  name="print" style="width:  20%;height:50px; border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);" (click)="PrintFollowUp()">Print</button>
                        <a href="Home">
                        <button type="button"  style="width:  20%;height:50px; border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);" name="Back">Home</button>
                        </a>
                        <div class="clear"> </div>
                    </div>
                </form>
            </div>


            <div class="appointment-form">
                <BR>
                <BR>
                <div>
                <label style="background-color: rgb(78, 150, 245);color: white; font-weight: bolder; font-size: x-large;height: 70px;"  aria-hidden="true">   Patient Follow up Visits   </label>
                </div>
                <BR>
                <label style="background-color: rgb(78, 150, 245);color: white; font-weight: bolder; font-size: x-large;width: 160px;"  aria-hidden="true">                 </label>
                <label style="background-color: rgb(246, 248, 250);color: white;width: 160px;"  aria-hidden="true">|</label>
                <label style="background-color: rgb(78, 150, 245);color: white; font-weight: bolder; font-size: x-large;width: 160px;"  aria-hidden="true">            CBC             </label>
                <label style="background-color: rgb(246, 248, 250);color: white;width: 160px;"  aria-hidden="true">|</label>
                <label style="background-color: rgb(78, 150, 245);color: white; font-weight: bolder; font-size: x-large;width: 160px;"  aria-hidden="true">                                                                                             </label>

                <table>
                  <thead style="font-size: 80%;">

                      <tr >
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 150px;">Date</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 20px;">HB</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 20px;">TCL</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 20px;">PNL's</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 20px;">PLAT</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 150px;">Protocol</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 15px;">Dose</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 30px;">Unit</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 30px;">Rote</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 10px;">Day</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 15px;">Cycle</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 150px;">Doctor</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 70px;">Next cycle</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 15px;">▄</th>

                        </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let res of TTTFollowUpList; let i = index" [ngStyle]="{'color':  styleColor[i]}">
                        <td data-column="Patient ID">{{res.tttdate}}</td>
                        <td data-column="cbchb Date" style="text-align: center;">{{res.cbchb}}</td>
                        <td  data-column="cbctlc Time" style="text-align: center;">{{res.cbctlc}}</td>
                        <td  data-column="cbcpnl Time" style="text-align: center;">{{res.cbcpnl}}</td>
                        <td data-column="cbcplat" style="text-align: center;">{{res.cbcplat}}</td>
                        <td data-column="protocol Name">{{res.protocolName}}</td>
                        <td data-column="tttdose Name">{{res.tttdose}}</td>
                        <td data-column="tttunit Name">{{res.unitname}}</td>
                        <td data-column="tttrote Name">{{res.tttrote}}</td>
                        <td data-column="tttday Name">{{res.tttday}}</td>
                        <td data-column="tttcycleno Name">{{res.tttcycleno}}</td>
                        <td data-column="Doctor Name">{{res.docname}}</td>
                        <td data-column="Status">{{res.tttnextcycle}}</td>
                        <td data-column="Select">  <button type="button"  name="New" style="background-color: rgba(42, 92, 217, 0.385);height: 25px;border-radius: 4px;transition: 0.3s ease;border: 1px solid var(--theme-color);" matTooltip="Click to Select to Update" (click)="SelectTTTFollowUp(res)"></button>
                          </td>
                      </tr>


                  </tbody>

              </table>

            </div>

        </div>
        <div class="clear"> </div>
    </div>
  </section>

  </div>
